import React, { useState, useEffect } from 'react';
import { MoreHorizontal, Clock, RefreshCw } from "lucide-react";
import ApiService from '../services/apiService';

const TodaysPlan = () => {
  const [todaysClasses, setTodaysClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiService = new ApiService();

  const fetchTodaysPlan = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Get actual lesson plan from shikshak agent
      const today = new Date();
      const weekStart = new Date(today.setDate(today.getDate() - today.getDay()));
      const weekEnd = new Date(today.setDate(today.getDate() - today.getDay() + 6));
      const weekString = `${weekStart.toLocaleDateString()} - ${weekEnd.toLocaleDateString()}`;
      
      // Make real API call to shikshak agent
      const response = await apiService.generateLessonPlan(weekString, ['3', '4', '5'], 'General');
      
      // Transform real API response to plan format
      if (response && response.status === 'success' && response.data) {
        const transformedData = [
          {
            subject: "AI Content Generation",
            class: "Vidya Agent Module",
            topics: response.data.totalActivities || 8,
            duration: 45,
            color: "bg-purple-500",
            initial: "A",
          },
          {
            subject: "Student Material Creation",
            class: "Vidyarthi Agent Module",
            topics: response.data.grades?.length * 3 || 12,
            duration: 60,
            color: "bg-blue-500",
            initial: "S",
          },
          {
            subject: "Teacher Lesson Planning",
            class: "Shikshak Agent Module",
            topics: response.data.weekActivities?.length || 6,
            duration: 30,
            color: "bg-green-500",
            initial: "T",
          }
        ];
        setTodaysClasses(transformedData);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Failed to fetch today\'s plan:', err);
      setError(err.message);
      // Use fallback data on error
      setTodaysClasses([
        {
          subject: "Workflow Automation",
          class: "Module 1",
          topics: 8,
          duration: 45,
          color: "bg-purple-500",
          initial: "W",
        },
        {
          subject: "Content Generation",
          class: "Module 2", 
          topics: 12,
          duration: 60,
          color: "bg-blue-500",
          initial: "C",
        },
        {
          subject: "Visual Management",
          class: "Module 3",
          topics: 6,
          duration: 30,
          color: "bg-green-500",
          initial: "V",
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodaysPlan();
  }, []);
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 h-fit">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-gray-900">Today's Plan</h2>
        <div className="flex items-center gap-2">
          <button 
            onClick={fetchTodaysPlan}
            disabled={loading}
            className="text-blue-600 hover:text-blue-700 p-1 rounded transition-colors duration-200 disabled:opacity-50"
            title="Refresh Plan"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
          </button>
          <button className="text-blue-600 hover:text-blue-700 font-medium text-sm transition-colors duration-200">
            View All
          </button>
        </div>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-yellow-800 text-sm">⚠️ Using cached data. API unavailable: {error}</p>
        </div>
      )}

      <div className="space-y-3">
        {todaysClasses.map((classItem, index) => (
          <div
            key={index}
            className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg hover:bg-red-50 transition-colors duration-200 group"
          >
            <div
              className={`w-12 h-12 ${classItem.color} rounded-lg flex items-center justify-center text-white font-bold text-lg group-hover:scale-110 transition-transform duration-200`}
            >
              {classItem.initial}
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-900 text-sm">{classItem.subject}</h3>
              <p className="text-gray-600 text-sm">{classItem.class}</p>
              <div className="flex items-center gap-4 mt-1 text-xs text-gray-500">
                <span>{classItem.topics} Topics</span>
                <div className="flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  <span>{classItem.duration} mins</span>
                </div>
              </div>
            </div>

            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-red-200 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100">
              <MoreHorizontal className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodaysPlan;